import type { WithDescending } from '@/types/graphql'
import type { ExportFormat, ExportOption } from '@/modules/exports'
import type { IssueSeverity } from './types.graphl'

export const ISSUE_STATUS_FILTERS = ['OPEN', 'STARTED', 'CLOSED'] as const
export type IssueStatusFilter = (typeof ISSUE_STATUS_FILTERS)[number]

export const ISSUE_INVOLVEMENT_FILTERS = ['INVOLVED', 'NOT_INVOLVED'] as const
export type IssueInvolvementFilter = (typeof ISSUE_INVOLVEMENT_FILTERS)[number]

export type IssueOrderFields =
  | WithDescending<'createdAt'>
  | WithDescending<'timeOfIssueStart'>
  | WithDescending<'user__firstName'>
  | WithDescending<'category__name'>
  | WithDescending<'severity'>
  | WithDescending<'riskAspect__name'>
export interface IssuesTableFilter {
  query: string
  orderBy: IssueOrderFields
  excludeCategories: string[]
  statuses: IssueStatusFilter[]
  severities: IssueSeverity[]
  archived: boolean
  relatedInfringement?: string | null
  onlyManuallyCreated: boolean
  involvement: IssueInvolvementFilter[]
  leaderGroup: null | string
  tags: string[]
  dateRange: {
    from: Date
    to: Date
  }
}

export interface CloseIssueForm {
  solution: string
  actualCost: number | null
}

export interface EditIssueForm {
  user: string | null
  responsibleUser: string | null
  caseHandler: string | null
  closed: boolean
  archived: boolean
  category: string | null
  subcategory: string | null
  date: Date
  dateEnd: Date

  placename: string
  regNr: string | null
  title: string
  description: string
  damage: string
  reason: string
  locationDescription: string
  immediateAction: string
  action: string

  estimatedCost: number
  suggestedSolution: string
  actualCost: number | null
  solution?: string
  severity: IssueSeverity | null
  riskAspect: string | null

  processChoice: string | null

  /**
   * Map of IssueRelation.id -> selected IssueRelationOption.id (or null).
   * Empty entry = no option chosen for that relation.
   */
  relationOptions: Record<string, string | null>

  tags: string[]
}

export interface ExportIssueForm {
  recipients: string[]
  exportOption: ExportOption
  exportType: string
  exportFormat: ExportFormat
  customExportText?: string
}

export interface ExportIssuesMassForm
  extends Omit<ExportIssueForm, 'id' | 'recipients'> {
  recipients?: string[]
  user: string | null
  dateStart: Date
  dateEnd: Date
  month: Date
  useDateRange: boolean
  includeArchived: boolean
}
